import { useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

export function useKeyboardShortcuts() {
  const navigate = useNavigate()
  
  const handleKeyDown = useCallback((e) => {
    // Ignore if typing in input or textarea
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable) {
      return
    }
    
    // Check for modifier key (Cmd on Mac, Ctrl on Windows)
    const modifier = e.metaKey || e.ctrlKey
    
    if (modifier) {
      switch(e.key.toLowerCase()) {
        case 'd':
          e.preventDefault()
          navigate('/')
          break
        case 'u':
          e.preventDefault()
          navigate('/users')
          break
        case 't':
          e.preventDefault()
          navigate('/teams')
          break
        case 's':
          e.preventDefault()
          navigate('/support')
          break
        case 'p':
          e.preventDefault()
          navigate('/payments')
          break
        case 'k':
          e.preventDefault()
          // Open command palette (could be implemented later)
          document.dispatchEvent(new CustomEvent('open-command-palette'))
          break
      }
    }
    
    // Quick navigation without modifier
    if (e.key === '?' && e.shiftKey) {
      e.preventDefault()
      document.dispatchEvent(new CustomEvent('show-shortcuts'))
    }
  }, [navigate])
  
  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [handleKeyDown])
}

export function KeyboardShortcutsHelp({ isOpen, onClose }) {
  if (!isOpen) return null
  
  const shortcuts = [
    { keys: ['⌘', 'D'], action: 'Go to Dashboard' },
    { keys: ['⌘', 'U'], action: 'Go to Users' },
    { keys: ['⌘', 'T'], action: 'Go to Teams' },
    { keys: ['⌘', 'S'], action: 'Go to Support' },
    { keys: ['⌘', 'P'], action: 'Go to Payments' },
    { keys: ['?'], action: 'Show shortcuts' },
  ]
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={onClose}>
      <div className="bg-zinc-800 rounded-2xl p-6 shadow-2xl max-w-md w-full mx-4" onClick={e => e.stopPropagation()}>
        <h2 className="text-lg font-bold mb-4">Keyboard Shortcuts</h2>
        <div className="space-y-3">
          {shortcuts.map((s, i) => (
            <div key={i} className="flex items-center justify-between">
              <span className="text-zinc-300">{s.action}</span>
              <div className="flex gap-1">
                {s.keys.map((k, j) => (
                  <kbd key={j} className="px-2 py-1 bg-zinc-800 rounded text-sm font-mono">{k}</kbd>
                ))}
              </div>
            </div>
          ))}
        </div>
        <p className="mt-4 text-xs text-zinc-500">Use Ctrl instead of ⌘ on Windows</p>
        <button 
          onClick={onClose}
          className="mt-4 w-full py-2 bg-zinc-900 text-white rounded-lg hover:bg-zinc-700"
        >
          Close
        </button>
      </div>
    </div>
  )
}
